(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[148],{

/***/ 30669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coverage",
      function () {
        return __webpack_require__(69777);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_coverage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.ts + 136 modules
var components = __webpack_require__(13823);
// EXTERNAL MODULE: ./src/layouts/index.ts + 17 modules
var layouts = __webpack_require__(63409);
// EXTERNAL MODULE: ./src/truck/label/index.tsx
var label = __webpack_require__(67734);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
;// CONCATENATED MODULE: ./src/screens/coverage/elements.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ac0cbcf0-0"
})(_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable);

// EXTERNAL MODULE: ./src/hooks/use-coverage.ts
var use_coverage = __webpack_require__(13624);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/screens/coverage/zone/column.js

function column_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > :not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    column_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e565c03e-0"
})(column_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy);
var Column = function(props) {
    var data = props.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: (0,lodash.map)(data, function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: item.name
            });
        })
    });
};
/* harmony default export */ var zone_column = (Column);

// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/truck/utils/index.ts + 8 modules
var utils = __webpack_require__(14250);
;// CONCATENATED MODULE: ./src/screens/coverage/zone/elements.js

function elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n\n  ",
        ";\n"
    ]);
    elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-rows: auto;\n  grid-column-gap: ",
        "px;\n  grid-row-gap: ",
        "px;\n  grid-template-columns: 1fr;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Name = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-cb6573a5-0"
})(elements_templateObject(), theme/* default.spacing.cozy */.Z.spacing.cozy, (0,utils/* getTextStyle */.BN)("h5Bold"));
var elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb6573a5-1"
})(_templateObject1(), theme/* default.spacing.cozy */.Z.spacing.cozy, theme/* default.spacing.cozy */.Z.spacing.cozy, (0,styled_breakpoints.up)("lg"));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/screens/coverage/zone/find-last-children.js


var findLastChildren = function(node) {
    var children = node.children;
    if (!children) {
        return (0,lodash.castArray)(node);
    }
    return (0,lodash.reduce)(children, function(result, child) {
        var lastChildren = findLastChildren(child);
        return lodash.concat.apply(void 0, [
            result
        ].concat((0,_to_consumable_array/* default */.Z)((0,lodash.castArray)(lastChildren))));
    }, []);
};
/* harmony default export */ var find_last_children = (findLastChildren);

;// CONCATENATED MODULE: ./src/screens/coverage/zone/index.js






var distributeInColumns = function(items, numberOfColumns) {
    var completeColumns = Math.floor(items.length % numberOfColumns);
    var nextIndex = 0;
    var distribute = function(index) {
        var isCompleteColumn = index < completeColumns;
        var size = Math.floor(items.length / numberOfColumns);
        if (isCompleteColumn) {
            size += 1;
        }
        var columnItems = items.slice(nextIndex, nextIndex + size);
        nextIndex += size;
        return columnItems;
    };
    return (0,lodash.times)(numberOfColumns, distribute);
};
var Zone = function(props) {
    var node = props.node, zoneIdToShow = props.zoneIdToShow, onZoneClick = props.onZoneClick;
    var coverage = find_last_children(node);
    var coverageWithFourColumns = distributeInColumns(coverage, 4);
    var renderColumns = function(column, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(zone_column, {
            data: column,
            zoneIdToShow: zoneIdToShow,
            onZoneClick: onZoneClick
        }, index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                children: node.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_Content, {
                children: (0,lodash.map)(coverageWithFourColumns, renderColumns)
            })
        ]
    });
};
/* harmony default export */ var zone = (Zone);

;// CONCATENATED MODULE: ./src/screens/coverage/zones/elements.js

function zones_elements_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n  object-fit: cover;\n  width: 100%;\n\n  ",
        " {\n    max-height: ",
        "px;\n  }\n"
    ]);
    zones_elements_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function elements_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-row-gap: ",
        "px;\n"
    ]);
    elements_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-4ef6b28c-0"
})(zones_elements_templateObject(), theme/* default.spacing.comfortable */.Z.spacing.comfortable, (0,styled_breakpoints.up)("lg"), theme/* default.spacing.cozy */.Z.spacing.cozy * 60);
var zones_elements_Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ef6b28c-1"
})(elements_templateObject1(), theme/* default.spacing.relaxed */.Z.spacing.relaxed);
var elements_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4ef6b28c-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/screens/coverage/zones/component.js





var ZonesContent = function(props) {
    var coverageTree = props.coverageTree, coverageImage = props.coverageImage;
    var ref = (0,react.useState)(null), zoneIdToShow = ref[0], setZoneIdToShow = ref[1];
    var onZoneClick = function(id) {
        return setZoneIdToShow(id);
    };
    var renderZone = function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(zone, {
            node: item,
            zoneIdToShow: zoneIdToShow,
            onZoneClick: onZoneClick
        }, item.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(elements_Container, {
        children: [
            coverageImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: coverageImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zones_elements_Content, {
                children: (0,lodash.map)(coverageTree, renderZone)
            })
        ]
    });
};
/* harmony default export */ var component = (ZonesContent);

;// CONCATENATED MODULE: ./src/screens/coverage/zones/index.tsx




function Zones() {
    var ref = (0,use_coverage/* default */.Z)(), loading = ref.loading, coverageImage = ref.coverageImage, coverageTree = ref.coverageTree;
    if (loading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(component, {
        coverageImage: coverageImage,
        coverageTree: coverageTree
    });
}
/* harmony default export */ var zones = (Zones);

;// CONCATENATED MODULE: ./src/screens/coverage/index.tsx






var CoverageScreen = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* DefaultLayout */.HQ, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* default */.Z, {
                as: "p",
                $textStyle: "h4Semibold",
                style: {
                    flexShrink: 0
                },
                children: "Nuestra cobertura"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zones, {})
            })
        ]
    });
};
/* harmony default export */ var coverage = (CoverageScreen);

// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var src_utils = __webpack_require__(90644);
;// CONCATENATED MODULE: ./pages/coverage.tsx







function CoveragePage(props) {
    var metaInfo = props.metaInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Meta */.h_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaInfo), {
                title: "Cobertura"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(coverage, {})
        ]
    });
}
CoveragePage.getInitialProps = function(context) {
    return {
        metaInfo: (0,src_utils/* getMetaInfo */.R7)(context)
    };
};
/* harmony default export */ var pages_coverage = (CoveragePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [157,3409,9774,2888,179], function() { return __webpack_exec__(49484), __webpack_exec__(30669); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);